exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xxx[data-v-76d384e4]{color:#000}", ""]);

// exports
